<template>
    <div class="card-installments d-flex flex-column flex-fill">
        <div class="flex-fill">
            <CieloSelect
                @change="selectItem"
                :title="$ml.get('installment')"
                :label="$ml.get('installmentsNumber')"
                :option-items="installmentList"
                :selected-item="numberOfInstallments"
                :on-get-item-event="getLangOptions"
                :disabled="this.installmentIsFixed"
            />
        </div>

        <div class="spacing-t-6">
            <ButtonsNextPrevious
                :disable-button-next="!this.numberOfInstallments"
                @click-next="goToNextPage"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Token, Options } from '@/config/lang/genericOptions.js';
import { logEvent } from '@/helpers/cieloLogger';

import ButtonsNextPrevious from '@/components/template/ButtonsNextPrevious.vue';
import CieloSelect from '@/components/template/CieloSelect/CieloSelect.vue';

export default {
  components: {
    ButtonsNextPrevious,
    CieloSelect
  },

  computed: {
    ...mapGetters({
      installmentList: 'payment/getInstallmentListForPaymentMethodSelected',
      installmentIsFixed: 'payment/getSelectedPaymentMethodInstallmentIsAbleToBeFixed',
    }),
    numberOfInstallments: {
      get: (self) =>
        self.$store.getters['payment/getInstallmentNumberOfPayments'],
      set(value) {
        this.$store.commit('payment/setNumberOfInstallments', value);
      },
    },
  },

  data() {
    return {
      itemSelected: false,
    };
  },

  methods: {
    goToNextPage() {

		logEvent({

			category: 'checkout',
			action: 'forma_pagamento_qr-code_credito',
			label: 'Usuário escolhe a forma de pagamento qr-code e escolhe a quantidade de parcelas'

		});

      this.$store.dispatch('pipeline/pushNext');
      return;
    },

    goToPreviousStep() {
      this.$store.commit('payment/setNumberOfInstallments', 0);
      this.$store.dispatch('pipeline/pushPrevious');
    },

    selectItem(item) {
      this.numberOfInstallments = item;
    },

    getLangOptions(item) {
      let tokens = [];

      tokens.push(new Token('quantity', item.Value));
      tokens.push(new Token('installmentPrice', item.installmentPrice));

      return new Options('installmentsItem', tokens);
    },
  },
};
</script>
<style scoped lang="scss">
    .card-installments {}

</style>
